import { AuthLogout } from "@redux/actionCreators/authActions";
import store from "@redux/store/store";
import axios, { AxiosInstance } from "axios";

var config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const setAuthorizationToken = (axios: AxiosInstance, token: string | null) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

const redirectToLogin = () => {
  store.dispatch(AuthLogout());
  window.location.replace("/");
};
export class AxiosReq {
  static post(url: string, params: Record<string, any>, token: string | null = null) {
    setAuthorizationToken(axios, token);
    return new Promise((fulfill, reject) => {
      axios
        .post(`${process.env.REACT_APP_API_URL}` + url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  static put(url: string, params: Record<string, any>, token: string | null = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .put(`${process.env.REACT_APP_API_URL}` + url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  static get(url: string, token: string | null = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .get(`${process.env.REACT_APP_API_URL}` + url, config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  static patch(url: string, params: Record<string, any>, token: string | null = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .patch(`${process.env.REACT_APP_API_URL}` + url, JSON.stringify(params), config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }

  static delete(url: string, token: string | null = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .delete(`${process.env.REACT_APP_API_URL}` + url, config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  };

  // post Form Url Encoded
  static postFormUrlEncoded(url: string, params: Record<string, any>) {
    const configHeaders = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }
    return new Promise((fulfill, reject) => {
      axios
        .post(`${process.env.REACT_APP_API_URL}` + url, new URLSearchParams(params), configHeaders)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static postFile(url: string, params: Record<string, any>, token: string | null = null) {
    setAuthorizationToken(axios, token);
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data', // Set appropriate headers
        ...(token ? { Authorization: `Bearer ${token}` } : {}), // Add authorization token if provided
      },
    };
  
    return new Promise((fulfill, reject) => {
      axios
        .post(`${process.env.REACT_APP_API_URL}${url}`, params, config) // Pass formData for file uploads
        .then((response) => {
          fulfill(response.data);
        })
        .catch((error) => {
          if (error && error.response) {
            if (error.response.status === 401) {
              redirectToLogin();
            } else {
              reject(error.response?.data);
            }
          } else {
            reject(error);
          }
        });
    });
  }
  
  
}
